import {FC, useEffect, useMemo, useState} from "react";
import {useAppSelector} from "toolkit/hooks";
import {NoData} from "components-new/NoData/NoData";
import {Document} from "./Document/Document";
import styles from "./Tables.module.sass";
import cn from "classnames";

export const Tables: FC = () => {
	const { currentTab, documentList, objectList, detailedMode, versionMode, versionList } = useAppSelector(
		(state) => state.categorization,
	);
	const { searchValue } = useAppSelector((state) => state.documents);
	const [showVersions, setShowVersions] = useState<boolean>(false);

	useEffect(() => {
		if (versionMode) {
			setShowVersions(true);
		} else {
			setShowVersions(false);
		}
		//eslint-disable-next-line
	}, []);

	const tableHeaderTypes = {
		1: ["Название документа", "Дата загрузки", "Загрузил"],
		2: ["№", "Код", "Наименование", "Тип объекта", "Сфера деятельности объекта"],
		3: ["№", "Объект", "Название документа", "Дата утверждения", "Дата загрузки", "Загрузил"],
		4: ["№", "Партия документов", "Дата формирования", "Формировал партию", "Ответное письмо ФСТЭК", "Загрузил"],
	};

	const tabs = {
		ORDER: 1,
		PROCESS: 1,
		REGISTRY: 2,
		ENUM: 1,
		MODEL: 2,
		RESULT: 3,
		BUNDLE: 4,
	};

	type tabsTypeKey = keyof typeof tabs;
	type headerTypeKey = keyof typeof tableHeaderTypes;

	const filterList = useMemo((): any[] => {
		const list: any[] =
			(currentTab === "REGISTRY" || currentTab === "MODEL") && !detailedMode ? objectList : documentList;
		return list.filter(
			(item) =>
				item?.name?.toLowerCase()?.includes(searchValue.trim().toLowerCase()) ||
				item?.part?.toLowerCase()?.includes(searchValue.trim().toLowerCase()),
		);
		//eslint-disable-next-line
	}, [searchValue]);

	return (
		<>
			<table className={cn(styles["table-head"])}>
				<thead className={cn(styles.head, styles[`head-type-${detailedMode ? "1" : tabs[currentTab as tabsTypeKey]}`])}>
					<tr>
						{detailedMode
							? tableHeaderTypes[1]?.map((item: any, i: number) => <th key={i}>{item}</th>)
							: tableHeaderTypes[tabs[currentTab as tabsTypeKey] as headerTypeKey]?.map((item: any, i: number) => (
									<th key={i}>{item}</th>
							  ))}
					</tr>
				</thead>
			</table>
			{(currentTab !== "REGISTRY" && currentTab !== "MODEL" && documentList.length) ||
			((currentTab === "REGISTRY" || currentTab === "MODEL") && objectList.length) ? (
				<div data-comment-false={true} className={styles["table-body-wrp"]}>
					<table className={cn(styles["table-body"], currentTab === "RESULT" && styles.flex)}>
						<tbody className={styles.body}>
							{!showVersions &&
								(currentTab === "REGISTRY" || currentTab === "MODEL" ? (
									detailedMode ? (
										documentList.length ? (
											searchValue ? (
												filterList.length ? (
													filterList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} />)
												) : (
													<NoData title="Ничего не найдено" />
												)
											) : (
												documentList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} />)
											)
										) : (
											<NoData title="Данные отсутствуют" />
										)
									) : searchValue ? (
										filterList.length ? (
											filterList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} />)
										) : (
											<NoData title="Ничего не найдено" />
										)
									) : (
										objectList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} />)
									)
								) : searchValue ? (
									filterList.length ? (
										filterList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} />)
									) : (
										<NoData title="Ничего не найдено" />
									)
								) : (
									documentList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} />)
								))}
							{showVersions &&
								(versionList.length ? (
									versionList?.map((item, i) => <Document key={item?.id || i} document={item} i={i + 1} flag={true} />)
								) : (
									<NoData title="Ничего не найдено" />
								))}
						</tbody>
					</table>
				</div>
			) : (
				<NoData title="Данные отсутствуют" />
			)}
		</>
	);
};
